import gql from "graphql-tag";

export const updateDirtyStateMutation = gql`
  mutation updateDirtyState($data: Object!) {
    updateDirtyState(data: $data) @client
  }
`;

export const updateDirtyState = (_, { data }, { cache }) => {
  cache.writeData({
    data: {
      dirtyState: {
        __typename: "DirtyState",
        ...data,
      },
    },
  });

  return null;
};



// WEBPACK FOOTER //
// ./src/mutations/updateDirtyStateMutation.js